import styled from 'styled-components'
export const Wrapper = styled.div`
  .billing-date {
    color: var(--second-color);
  }
  .new-added {
    box-shadow: 0 0 10px var(--second-color-1);
    border-color: #ffd685 !important;
  }
  .card {
    transition: background-color 0.5s;
  }
`
